
export default {
  prompts: {
    "分析患者症状变化": "分析患者症状变化",
    "解读患者就诊病案": "以上病案从辨证分析（辨病依据、辨证依据）、遣方用药解析（处方思路、核心方剂、药物分类及功效）、药对配伍分析、性味归经与整体平衡、安全合理用药审核这几个方面进行病案分析。",
    "分析患者治疗效果": "症状发生频率是否减少、持续时间是否缩短、涉及的病变部位是否减少、严重程度是否减轻，伴随症状是否减少，是否存在药物反应，病理舌象是否减轻，生活质量和生活自理能力是否提升（如有），心理健康状态是否提升（如有），实验室指标是否趋于进入正常值范围。",
    "分析核心指标变化趋势":	"依据主诊断，检索该病种的主要疗效评价指标，并对比多次就诊后的主要疗效评价指标变化趋势",
    "就当前病历进行诊断开方": "诊断依据，辩证依据，鉴别诊断，处方药物和剂量解析。",
    "推荐名家处方":	"检索相同病名和症状下（证型受不同学派影响容易出现差异）的名家医案",
    "分析历次就诊的遣方用药": "症状、指标变化和药物加减变化的关联，可推出专家加减规则和疗效评价",

    '方解': '结合病历和处方告诉我这个处方的方解，包括方剂名称与原始记载来源、方剂的功能主治、方剂的适用范围（例如什么疾病什么证型）、君臣佐使、方剂在本例的变化与加减、方剂整体思路、方剂特点、该方剂的现代研究成果、注意事项与禁忌。',
    '诊断依据': '告诉我以上病历的诊断依据，包括辨病依据、辨证依据、开方依据。',
    '安全合理用药': '以上处方进行安全合理用药审查，包括中药配伍禁忌、毒性，中西药并用的安全合理性，中药处方需要包含：十八反、十九畏、毒性药物、疾病禁忌、慎禁忌、不宜同用、剂量超标、患者为儿童老人孕妇不宜用、禁止内服、不入煎剂等审查，还有其他你能想到的安全合理用药问题审查，尽可能详细。',
    '病历分析': "中医诊断（含主诊断和证候诊断）依据，疾病鉴别诊断分析，治则治法解释，方剂选择解释，预后可能性分析，健康教育指导。",
    '生成按语': '综合缩减诊断依据和治疗效果分析',
    '相似度分析': '按照以下分析维度对比分析学生处方和老师处方的辨证开方相似度：辨证准确性（核心指征匹配度）、药物组成分析（君臣佐使配伍/经典方剂应用/药效分类匹配/关键药物权重）、剂量合理性（特殊药对比例/安全范围）、治法对应性（治法的实现路径）、整体思路一致性（标本兼治/症状兼顾）。并按照以下形式输出分析结果：异同点对比表格、五维评分系统（对学生处方进行评分，每项0-20分，附评分理由，并计算出总分）、改进建议。',
  },
  mobileURI: process.env.VUE_APP_mobileURI,
  fileServerBaseUrl: '/api/v1/static/upload',
  fileUpLoadURL: '/api/v1/file/upload',

  ApiServerBaseUrl: '',
  // ApiServerBaseUrl: '/srip',
  CHOICE_ACTION: 0,
  UNCHOICE_ACTION: 1,

  SUCCESS_CODE: 100200,
  // 指定哪些专病可以看见BCLC选项
  BCLC_ZHUANBINGS: [
    "非小细胞肺癌"
  ],
  menu: [
    {
      name: '首页',
      code: 'home',
      path: '/home',
      order: 1,
      subMenu: []
    },
    {
      name: '病历管理',
      code: 'case',
      path: '/case/',
      order: 1,
      subMenu: [
        {
          name: '病历查询',
          code: 'case.inquire',
          path: '/case/inquire',
          order: 1
        },
        {
          name: '患者查询',
          code: 'case.patientInquirie',
          path: '/case/patientInquirie',
          order: 2
        },
        {
          name: '专病配置',
          code: 'case.config',
          path: '/case/configMgr',
          order: 3
        },
        {
          name: '专病采集',
          code: 'case.collection',
          path: '/case/zhuanbingNameList',
          order: 4
        },
        // {
        //   name: '疗效反馈',
        //   code: 'case.EfficacyFeedback',
        //   path: '/case/EfficacyFeedback',
        //   order: 5
        // },
        // {
        //   name: '专病病历诊断',
        //   code: 'case.zhuanbingDiagnosis',
        //   path: '/case/zhuanbingDiagnosis',
        //   order: 6
        // },
        // {
        //   name: '专病病历审核',
        //   code: 'case.zhuanbingCalibration',
        //   path: '/case/zhuanbingCalibration',
        //   order: 7
        // },
        {
          name: '全科病历采集',
          code: 'case.general',
          path: '/case/general',
          order: 5
        },
        {
          name: 'AI电子病历',
          code: 'case.aiMedcase',
          path: '/case/aiMedcase',
          order: 6
        },
      ]
    },
    {
      name: '教学',
      code: 'education',
      path: '/education',
      order: 3,
      subMenu: [
        {
          name: '师生交流',
          code: 'education.consultation',
          path: '/education/consultation',
          order: 1,
          default: true
        },
        {
          name: '典型病历库',
          code: 'education.typical_medcase',
          path: '/education/typical-medcase',
          order: 2,
          default: true
        },
        {
          name: '随机模拟开方',
          code: 'education.random_mock_diagnose',
          path: '/education/random-mock-diagnose',
          order: 3,
          default: true
        },
        {
          name: '模拟开方记录',
          code: 'education.mock_diagnose',
          path: '/education/mock-diagnose',
          order: 4,
          default: true
        },
        {
          name: '跟师笔记',
          code: 'education.teachers_notes',
          path: '/education/teachers_notes',
          order: 5,
          default: true
        },
        {
          name: '学习心得',
          code: 'education.learning_experience',
          path: '/education/learning_experience',
          order: 6,
          default: true
        },
      ]
    },
    {
      name: '成果管理',
      code: 'achievement',
      path: '/achievement',
      order: 4,
      subMenu: [
        {
          name: '医案库',
          code: 'achievement.medical_cases',
          path: '/achievement/medical_cases',
          order: 1,
          default: true
        },
        {
          name: '诊疗方案',
          code: 'achievement.diagnosis_treatment',
          path: '/achievement/diagnosis_treatment',
          order: 1,
          default: true
        },
        {
          name: '论文',
          code: 'achievement.paper',
          path: '/achievement/paper',
          order: 1,
          default: true
        },
        {
          name: '论著',
          code: 'achievement.treatise',
          path: '/achievement/treatise',
          order: 1,
          default: true
        },
        {
          name: '研究报告',
          code: 'achievement.research_report',
          path: '/achievement/research_report',
          order: 1,
          default: true
        },
        {
          name: '知识产权',
          code: 'achievement.patent',
          path: '/achievement/patent',
          order: 1,
          default: true
        },
        {
          name: '院内制剂',
          code: 'achievement.preparation',
          path: '/achievement/preparation',
          order: 4
        },
        {
          name: '新药证书',
          code: 'achievement.newdrug_certificate',
          path: '/achievement/newdrug_certificate',
          order: 4
        },
        {
          name: '继续教育项目',
          code: 'achievement.continuing_education',
          path: '/achievement/continuing_education',
          order: 4
        },
        {
          name: '视频管理',
          code: 'achievement.video',
          path: '/achievement/video',
          order: 1,
          default: true
        },
        {
          name: '视频维护',
          code: 'achievement.video_maintenance',
          path: '/achievement/video_maintenance',
          order: 1,
          default: true
        },
        {
          name: '读书心得',
          code: 'achievement.readingExperience',
          path: '/achievement/readingExperience',
          order: 1,
          default: true
        },
        {
          name: '经验',
          code: 'achievement.experience',
          path: '/achievement/experience',
          order: 1,
          default: true
        },
        {
          name: '获奖',
          code: 'achievement.award',
          path: '/achievement/award',
          order: 1,
          default: true
        },
        {
          name: '医话',
          code: 'achievement.medicalNotes',
          path: '/achievement/medicalNotes',
          order: 1,
          default: true
        },
      ]
    },
    {
      name: '科研分析',
      code: 'kyfx',
      path: '/kyfx',
      order: 1,
      subMenu: [
        {
          name: '分析池',
          code: 'kyfx.analysisPool',
          path: '/kyfx/analysisPool',
          order: 1
        },
        {
          name: '数据挖掘',
          code: 'kyfx.dataMining',
          path: '/kyfx/dataMining',
          order: 2
        },
        {
          name: '分析报告',
          code: 'kyfx.analysisReport',
          path: '/kyfx/analysisReport',
          order: 3
        },
      ]
    },
    {
      name: '系统管理',
      code: 'sys',
      path: '/sys',
      order: 1,
      subMenu: [
        {
          name: '工作室管理',
          code: 'sys.studio',
          path: '/sys/studio',
          order: 1
        },
        {
          name: '角色管理',
          code: 'sys.role',
          path: '/sys/role',
          order: 2
        },
        {
          name: '用户管理',
          code: 'sys.user',
          path: '/sys/user',
          order: 3
        },
        {
          name: '版本管理',
          code: 'sys.versionManage',
          path: '/sys/versionManage',
          order: 4
        }
      ]
    },
    {
      name: '基础管理',
      code: 'kwg',
      path: '/kwg',
      order: 5,
      subMenu: [
        {
          name: '疾病管理',
          code: 'kwg.disease',
          path: '/kwg/disease',
          order: 1,
          default: true
        },
        {
          name: '证型管理',
          code: 'kwg.syndrome',
          path: '/kwg/syndrome',
          order: 2
        },
        {
          name: '症状管理',
          code: 'kwg.symptom',
          path: '/kwg/symptom',
          order: 3
        },
        // {
        //   name: '院内制剂',
        //   code: 'kwg.preparation',
        //   path: '/kwg/preparation',
        //   order: 4
        // },
        {
          name: '中成药',
          code: 'kwg.zhongcheng',
          path: '/kwg/zhongcheng',
          order: 5
        },
        {
          name: '西药',
          code: 'kwg.westernMedicine',
          path: '/kwg/westernMedicine',
          order: 5
        },
        {
          name: '协定方',
          code: 'kwg.agreementParty',
          path: '/kwg/agreementParty',
          order: 6
        },
        {
          name: '食养商品',
          code: 'kwg.foodProducts',
          path: '/kwg/foodProducts',
          order: 7
        },
        {
          name: '嘱托模板',
          code: 'kwg.entrustTemplate',
          path: '/kwg/entrustTemplate',
          order: 8
        },
        {
          name: '适宜技术',
          code: 'kwg.suitableSkill',
          path: '/kwg/suitableSkill',
          order: 9
        },
        {
          name: '适宜技术部位',
          code: 'kwg.suitableSkillPart',
          path: '/kwg/suitableSkillPart',
          order: 10
        }
      ]
    },
    {
      name: '工作室管理',
      code: 'studio',
      path: '/studio',
      order: 2,
      subMenu: [
        {
          name: '工作室维护',
          code: 'studio.mgr',
          path: '/studio/mgr',
          order: 1,
          default: true
        },
        {
          name: '用户管理',
          code: 'studio.user',
          path: '/studio/user',
          order: 2
        },
        {
          name: '学员评价',
          code: 'studio.studentEvaluation',
          path: '/studio/studentEvaluation',
          order: 4
        },
        {
          name: '活动管理',
          code: 'studio.activity',
          path: '/studio/activity',
          order: 5
        },
        {
          name: '跟师管理',
          code: 'studio.teacherManagement',
          path: '/studio/teacherManagement',
          order: 6
        },
        {
          name: '年度计划',
          code: 'studio.annualPlan',
          path: '/studio/annualPlan',
          order: 7,
          default: true
        },
      ]
    }
  ],
  breadcrumb: {
    "case.general": [
      {
        name: '基本信息',
        routerName: 'case.general',
        disabled: undefined,
        params: {
          step: 0,
          patientId: undefined
        }
      },
      {
        name: '症状采集',
        routerName: 'case.general',
        disabled: undefined,
        params: {
          step: 1,
          patientId: undefined
        }
      },
      {
        name: '诊断、处方',
        routerName: 'case.diagnose',
        disabled: undefined,
        params: {
          patientId: undefined
        }
      },
      {
        name: '批注',
        routerName: 'case.calibration',
        disabled: undefined,
        params: {
          patientId: undefined
        }
      },
    ],
    "case.config": [
      {
        name: '基本信息',
        routerName: 'case.config',
        disabled: undefined,
        params: {
          step: 0,
          patientId: undefined
        }
      },
      {
        name: '症状采集',
        routerName: 'case.config',
        disabled: undefined,
        params: {
          step: 1,
          patientId: undefined
        }
      },
      {
        name: '疗效反馈',
        routerName: 'case.EfficacyFeedback',
        disabled: undefined,
        params: {
          step: 1,
          patientId: undefined
        }
      },
      {
        name: '诊断、处方',
        routerName: 'case.zhuanbingDiagnosis',
        disabled: undefined,
        params: {
          step: 1,
          patientId: undefined
        }
      },
      {
        name: '批注',
        routerName: 'case.zhuanbingCalibration',
        disabled: undefined,
        params: {
          patientId: undefined
        }
      },
    ]
  },
  earMap: {
    earShape: '望耳形',
    earColor: '望耳色',
    earInner: '望耳部反应点/物',
    tenderPoint: '压痛点',
    resistance: '电阻反应'
  },
  /* 申明每个界面需要跟踪的虚拟 DOM 名称 */
  pageKeyBoardMap: {
    diagnose: {
      first: "tcmName",
      keys: {
        tcmName: {
          pre: undefined,
          next: "syndromes"
        },
        syndromes: {
          // pre: "tcmName",
          next: "treatMethod"
        },
        treatMethod: {
          // pre: 'syndromes',
          next: 'westDisease'
        },
        westDisease: {
          // pre: 'treatMethod',
          next: 'domain.first'
        },
        "domain.first": {},
        "domain.end": {},
        domain: {
          outPre: 'westDisease',
          outNext: "dose"
        },
        dose: {
          pre: "domain.end",
          next: "usage"
        },
        usage: {
          pre: "dose",
          next: "note"
        },
        note: {
          pre: "usage",
          next: "acupunctureInfo"
        },
        acupunctureInfo: {
          pre: 'note',
          next: "save"
        }
      }
    },
    "case.general.input": {
      first: 'mainName',
      keys: {
        mainName: {
          next: 'mainYear'
        },
        mainYear: {
          // pre: 'mainName',
          next: 'mainMonth'
        },
        mainMonth: {
          // pre: 'mainYear',
          next: 'mainDay'
        },
        mainDay: {
          // pre: 'mainMonth',
          next: 'aggravatedDay'
        },
        aggravatedDay: {
          // pre: 'mainDay',
          next: 'otherName'
        },
        otherName: {
          // pre: 'mainDay',
          next: 'otherYear'
        },
        otherYear: {
          // pre: 'otherName',
          next: 'otherMonth'
        },
        otherMonth: {
          // pre: 'otherYear',
          next: 'otherDay'
        },
        otherDay: {
          // pre: 'otherMonth',
          next: 'currentInfo'
        },
        currentInfo: {
          // pre: 'otherDay',
          next: 'commonSymptom'
        },
        commonSymptom: {
          // pre: 'currentInfo',
          next: 'tongue'
        },
        tongue: {
          // pre: 'commonSymptom',
          next: 'pluse'
        },
        pluse: {
          // pre: 'tongue',
          next: 'earShape'
        },
        earShape: {
          // pre: 'pluse',
          next: "earColor"
        },
        earColor: {
          // "pre": "earShape",
          "next": "earInner"
        },
        earInner: {
          // "pre": "earColor",
          "next": "tenderPoint"
        },
        tenderPoint: {
          // "pre": "earInner",
          "next": "resistance"
        },
        resistance: {
          // "pre": "tenderPoint",
          "next": "navel"
        },
        navel: {
          // "pre": "resistance",
          "next": "inspection"
        },
        inspection: {
          // "pre": "navel",
          "next": "checklist"
        },
        checklist: {
          // "pre": "inspection",
          "next": "pastHistory"
        },
        pastHistory: {
          // pre: 'checklist'
        }
      }
    },
    "case.general": {
      first: 'patientName',
      keys: {
        patientName: {
          next: 'diagnoseTime'
        },
        diagnoseTime: {
          // pre: 'patientName',
          next: 'patientCard'
        },
        patientCard: {
          // pre: 'diagnoseTime',
          next: 'gender'
        },
        gender: {
          // pre: 'patientCard',
          next: 'dateBirth'
        },
        dateBirth: {
          // pre: 'gender',
          next: "age"
        },
        age: {
          // pre: 'dateBirth',
          next: 'height'
        },
        height: {
          // pre: 'age',
          next: 'weight'
        },
        weight: {
          // pre: 'height',
          next: 'highBp'
        },
        highBp: {
          // pre: 'weight',
          next: 'lowBp'
        },
        lowBp: {
          // pre: 'highBp',
          next: 'hr'
        },
        hr: {
          // pre: 'lowBp',
          next: 'bodyTemperature'
        },
        bodyTemperature: {
          // pre: 'hr',
          next: 'menstrualCycle'
        },
        menstrualCycle: {
          // pre: 'bodyTemperature',
          next: 'lastMenstrual'
        },
        lastMenstrual: {
          // pre: 'menstrualCycle',
        }
      }
    },
    "case.config": {
      first: 'patientName',
      keys: {
        patientName: {
          next: 'diagnoseTime'
        },
        diagnoseTime: {
          // pre: 'patientName',
          next: 'patientCard'
        },
        patientCard: {
          // pre: 'diagnoseTime',
          next: 'gender'
        },
        gender: {
          // pre: 'patientCard',
          next: 'dateBirth'
        },
        dateBirth: {
          // pre: 'gender',
          next: "age"
        },
        age: {
          // pre: 'dateBirth',
          next: 'height'
        },
        height: {
          // pre: 'age',
          next: 'weight'
        },
        weight: {
          // pre: 'height',
          next: 'highBp'
        },
        highBp: {
          // pre: 'weight',
          next: 'lowBp'
        },
        lowBp: {
          // pre: 'highBp',
          next: 'hr'
        },
        hr: {
          // pre: 'lowBp',
          next: 'bodyTemperature'
        },
        bodyTemperature: {
          // pre: 'hr',
          next: 'menstrualCycle'
        },
        menstrualCycle: {
          // pre: 'bodyTemperature',
          next: 'lastMenstrual'
        },
        lastMenstrual: {
          // pre: 'menstrualCycle',
        }
      }
    },
    "case.config.input": {
      first: 'mainName',
      keys: {
        mainName: {
          next: 'mainYear'
        },
        mainYear: {
          // pre: 'mainName',
          next: 'mainMonth'
        },
        mainMonth: {
          // pre: 'mainYear',
          next: 'mainDay'
        },
        mainDay: {
          // pre: 'mainMonth',
          next: 'aggravatedDay'
        },
        aggravatedDay: {
          // pre: 'mainDay',
          next: 'otherName'
        },
        otherName: {
          // pre: 'mainDay',
          next: 'otherYear'
        },
        otherYear: {
          // pre: 'otherName',
          next: 'otherMonth'
        },
        otherMonth: {
          // pre: 'otherYear',
          next: 'otherDay'
        },
        otherDay: {
          // pre: 'otherMonth',
          next: 'currentInfo'
        },
        currentInfo: {
          // pre: 'otherDay',
          next: 'commonSymptom'
        },
        commonSymptom: {
          // pre: 'currentInfo',
          next: 'tongue'
        },
        tongue: {
          // pre: 'commonSymptom',
          next: 'pluse'
        },
        pluse: {
          // pre: 'tongue',
          next: 'earShape'
        },
        earShape: {
          // pre: 'pluse',
          next: "earColor"
        },
        earColor: {
          // "pre": "earShape",
          "next": "earInner"
        },
        earInner: {
          // "pre": "earColor",
          "next": "tenderPoint"
        },
        tenderPoint: {
          // "pre": "earInner",
          "next": "resistance"
        },
        resistance: {
          // "pre": "tenderPoint",
          "next": "navel"
        },
        navel: {
          // "pre": "resistance",
          "next": "inspection"
        },
        inspection: {
          // "pre": "navel",
          "next": "checklist"
        },
        checklist: {
          // "pre": "inspection",
          "next": "pastHistory"
        },
        pastHistory: {
          // pre: 'checklist'
        }
      }
    },

    /* 专病下面的录入诊断界面用到的键*/
    "internal_medicine": {
      first: "internal0.tpl",
      keys: {
        /* 动态算出来的 */
      }
    },
    "mixin_medicine": {
      first: 'mixin0.tpl',
      keys: {
        /* 动态算出来的 */
      }
    },
    "therapeutic_goods_medicine": {
      first: 'therapeutic_good0.tpl',
      keys: {
        /* 动态算出来的 */
      }
    },
  },
  /* 本地存储白名单，白名单中的KEY，在清除的时候，不会删除 */
  localStorageWhiteKeys: [
    "medical.mgr-search",
    "education.consultation-search"
  ],
  specialMedcase: ["肿瘤", "癌病", "肝癌"],
  /* 中药处方用法列表[非药物] */
  useOptions: [
    {
      "label": "水煎服",
      "value": 0
    },
    {
      "label": "制膏",
      "value": 1
    },
    {
      "label": "茶饮",
      "value": 2
    },
    {
      "label": "外洗",
      "value": 3
    },
    {
      "label": "熏蒸",
      "value": 4
    },
    {
      "label": "外敷",
      "value": 5
    },
    {
      "label": "坐浴",
      "value": 6
    },
    {
      "label": "研细末醋调外用",
      "value": 7
    },
    {
      "label": "研细末酒调外用",
      "value": 8
    },
    {
      "label": "研细末麻油调外用",
      "value": 9
    },
    {
      "label": "研细末蜜调外用",
      "value": 10
    },
    {
      "label": "香囊",
      "value": 11
    },
    {
      "label": "足浴包",
      "value": 12
    }
  ],

  /* 内服类型中药编号 */
  drinkType: [0, 1, 2, "水煎服", "制膏", "茶饮"],
  // 内服
  neiFuType: [
    "水煎服",
    "制膏",
    "茶饮"
  ],
  // 外用
  waiYongType: [
    "外洗",
    "熏蒸",
    "外敷",
    "坐浴",
    "研细末醋调外用",
    "研细末酒精调外用",
    "研细末麻油调外用",
    "研细末蜜调外用",
    "香囊",
    "足浴包"
  ],
  /* 中药处方频次 */
  durationOptions: [
    {
      "label": "一日1次",
      "value": 0
    },
    {
      "label": "一日2次",
      "value": 1
    },
    {
      "label": "一日3次",
      "value": 2
    },
    {
      "label": "二日1次",
      "value": 3
    },
    {
      "label": "三日1次",
      "value": 4
    }
  ],
  /* 中药单位 */
  unitOptions: [
    {
      label: '克',
      value: 0
    },
    {
      label: '毫克',
      value: 1
    }
  ],
  /* 中药服用时间*/
  useOrderOptions: [
    {
      label: '饭前服',
      value: 0
    },
    {
      label: '饭后服',
      value: 1
    },
    {
      label: '早饭前半小时服',
      value: 2
    },
    {
      label: '晚睡前一小时服',
      value: 3
    }
  ],
  /* 中西协定方药物类型 */
  mixinMedicineType: {
    hs: '制剂',
    ws: '西',
    pt: '中成药'
  },
  /* 院内制剂用法、西药 用法列表 */
  mixin_usage: {
    0: "口服",
    1: "开水冲服",
    2: "外敷"
  },
  mixin_pin: {
    0: "一日1次",
    1: "一日2次",
    2: "一日3次",
    3: "两日1次",
    4: "三日1次"
  },
  goods_pin: {
    0: "一日1次",
    1: "一日2次",
    2: "一日3次",
  },
  mixin_depths: {
    0: "天",
    1: "地",
    2: "人",
  },
  mixin_distributeds: {
    0: '双',
    1: '痛侧',
    2: '痛对侧',
    3: '左',
    4: '右',
    5: '其他',
  },
  mixin_punctures: {
    0: '直刺',
    1: '平刺',
    2: '斜刺'
  },
  mixin_techniques: {
    0: '无',
    1: '震颤',
    2: '捻针'
  },
  shouFaOptions: [
    {
      label: '无',
      value: 0
    },
    {
      label: '震颤',
      value: 1
    },
    {
      label: '捻针',
      value: 2
    }
  ],
  // 适宜技术类型
  actionTypes: [
    "毫针类",
    "特殊针具类",
    "腧穴特种治疗技术",
    "拔罐类",
    "艾灸类",
    "刮痧类",
    "耳穴类",
    "推拿类",
    "穴位敷贴"
  ],
  SolutionTypes: [
    // 中药方
    "neifu_medicine",
    "waiyong_medicine",
    // "internal_medicine",
    // 中西成药
    "mixin_medicine",
    // 适宜技术
    "appropriate_tech_medicine",
    // 食养方
    "therapeutic_goods_medicine"
  ]
}

